import { abyssColors } from '@/theme/colors';
import { Stack, Box, Typography, styled as muiStyled } from '@mui/material';

/**
 * Styled components and utilities for Platform Condition Charts
 * Following Material-UI theming and existing codebase conventions
 */

type WidgetProps = {
  loading?: boolean;
};

export const PlatformConditionWidget = muiStyled(Stack)(({ loading }: WidgetProps) => ({
  padding: '1.6rem',
  flex: '1 0',
  minHeight: '35rem',
  borderRadius: loading ? '0.6rem' : '0.8rem',
  border: loading ? 'none' : `0.1rem solid ${abyssColors.primary[200]}`,
  background: loading ? 'rgba(241, 239, 239, 0.40)' : abyssColors.neutral[50],
  flexDirection: 'column',
  gap: '1.6rem',
  transition: 'background ease 0.3s',
  '& .MuiSkeleton-root::after': {
    width: '150%',
    background: 'linear-gradient(90deg, transparent, rgba(217, 217, 217, 0.5), transparent)',
  },
}));

export const ChartsContainer = muiStyled(Stack)({
  overflowX: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  paddingTop: '1.6rem',
  paddingBottom: '1.6rem',
  width: '100%',
});

export const DonutChartContainer = muiStyled(Box)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '2rem',
});

export const ChartTitle = muiStyled(Typography)({
  fontSize: '1.6rem',
  fontWeight: `${700} !important`,
  color: '#224063',
  textAlign: 'left',
  alignSelf: 'flex-start',
  marginLeft: '1.4rem',
  marginBottom: '1.5rem',
});
export const LegendContainer = muiStyled(Stack)({
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '3rem',
  justifyContent: 'center',
  alignItems: 'center',
});

export const LegendItem = muiStyled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.6rem',
});

export const LegendDot = muiStyled(Box)<{ color: string }>(({ color }: { color: string }) => ({
  width: '1.2rem',
  height: '1.2rem',
  // borderRadius: '50%',
  backgroundColor: color,
  flexShrink: 0,
}));

export const LegendLabel = muiStyled(Typography)({
  fontSize: '1.2rem',
  color: abyssColors.primary[400],
  fontWeight: 400,
});

// Recharts tooltip container for simple content
export const ChartTooltipBox = muiStyled(Box)({
  background: '#ffffff',
  border: '1px solid rgba(0,0,0,0.12)',
  padding: '6px 8px',
  borderRadius: 4,
});
